import React from "react";
import { Col, Row } from "react-bootstrap";

const SectionNav = ({ sections, scrollToSection }) => (
    <Col lg={2} className="section-navigation-myPreference">
        {sections.map(({ id, label }) => (
            <Row key={id} className="page-link-myPreference">
                <a
                    id={`${id}-link`}
                    className="item"
                    role="button"
                    tabIndex={0}
                    onClick={(e) => scrollToSection(e, id)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            scrollToSection(e, id);
                        }
                    }}
                >
                    {label}
                </a>
            </Row>
        ))}
    </Col>
);

export default SectionNav;